import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { BodyText } from 'palette/Typography';
import { filterSelectors } from '@common/Filters/selectors';
import { useConfig } from '@common/Hooks/useConfig';
import { persistFilters } from '@common/Listing/helpers/listingLinks';
import '../styles/ListingTopMainLink.scss';

const getLinkHref = (linkData, config, filters) => {
    const { URLPrefix } = config;
    const { type, skip_prefix: skipPrefix, url } = linkData;
    const href = skipPrefix ? url : [URLPrefix, url].join('');

    if (type === 'listing') {
        return persistFilters(href, filters);
    }

    return href;
};

export function ListingTopMainLink({ customClass, link }) {
    const config = useConfig();
    const { name } = link;
    const activeFilters = useSelector(filterSelectors.activeFilters);

    return (
        <a
            className={classnames('listing-top-main-link', customClass)}
            href={getLinkHref(link, config, activeFilters)}

        >
            <BodyText
                color="light"
                level="2"
            >
                {name}
            </BodyText>
        </a>
    );
}
